import { render, staticRenderFns } from "./language-selector.vue?vue&type=template&id=389022dc"
import script from "./language-selector.vue?vue&type=script&lang=js"
export * from "./language-selector.vue?vue&type=script&lang=js"
import style0 from "./language-selector.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports